// == Import : npm
import { connect } from 'react-redux';

// == Import : local
import Login from '../../screen/Login';

// Action Creators
import { login, me } from '../../store/reducer';

const mapStateToProps = (state, ownProps) => ({
  //datas: state.datas,
  waitingRequest: state.waitingRequest,
  connected: state.connected,
  messageNotif: state.messageNotif,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  login: (mail, password) => {
    dispatch(login(mail, password, ownProps.history));
  },
  me: () => {
    dispatch(me());
  },
});

// Container
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Login);